import { useEffect, useState } from "react";
import purchase_logo from "assets/images/icons/purchase_logo.png";
import Brands from "components/purchase/Brands";
import Faqs from "components/purchase/Faqs";
import Features from "components/purchase/Features";
import Features2 from "components/purchase/Features2";
import GradientCard from "components/purchase/GradientCard";
import Testimonial from "components/purchase/Testimonial";
import TimeLine from "components/purchase/TimeLine";
import { BlueTickIcon } from "utils/Icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "redux/reducers/authReducerSlice";
import axios from "axios";
import { auth } from "config/firebase";
import {
  configureRevenueCat,
  getWebOffering,
  purchasePackage,
  packagePriceNumber,
  splitPackages,
  isEntitled,
} from "config/revenuecat";

//
const Purchase = () => {
  const { data: user } = useSelector((store) => store.auth);
  const navigate = useNavigate();
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("Yearly");
  const [planPrices, setPlanPrices] = useState({
    monthly: 19.99,
    yearly: 99.0,
    trial_period: 7,
    loading: true,
  });
  // RevenueCat packages backing the two CTAs.
  const [packages, setPackages] = useState({ monthly: null, yearly: null });
  const [purchasing, setPurchasing] = useState(false);
  const [actionError, setActionError] = useState(null);
  const dispatch = useDispatch();

  // close modal
  const closeModal = () => {
    setPurchaseModal(false);
  };
  // toggle modal
  const toggleModal = () => {
    setPurchaseModal(!purchaseModal);
  };
  //
  const selectAPlan = (id) => {
    setSelectedPlan(id);
  };

  // RevenueCat Web Billing: configure with the Firebase uid (same App User ID
  // the mobile apps use, so a web purchase is the same RevenueCat customer),
  // then load the offering to price the two CTAs.
  useEffect(() => {
    const appUserId = auth.currentUser?.uid;
    if (!configureRevenueCat(appUserId)) {
      setPlanPrices((p) => ({ ...p, loading: false }));
      return;
    }

    let cancelled = false;
    getWebOffering()
      .then((offering) => {
        if (cancelled) return;
        const { monthly, yearly } = splitPackages(offering);
        setPackages({ monthly, yearly });
        setPlanPrices((prev) => ({
          monthly: packagePriceNumber(monthly) ?? prev.monthly,
          yearly: packagePriceNumber(yearly) ?? prev.yearly,
          // Trial length lives on the RevenueCat product/offer; keep the
          // marketing default until the dashboard offering is configured.
          trial_period: prev.trial_period,
          loading: false,
        }));
      })
      .catch((err) => {
        if (cancelled) return;
        console.warn("[RevenueCat] getOfferings failed:", err);
        setPlanPrices((p) => ({ ...p, loading: false }));
      });

    return () => {
      cancelled = true;
    };
  }, []);

  /**
   * Opens RevenueCat's hosted checkout. Access is still gated on the backend's
   * `user.subscribed` (set by the RevenueCat webhook), so on success we refetch
   * /me and optimistically flip `subscribed` so the redirect isn't blocked by
   * webhook latency.
   */
  const startPurchase = async (rcPackage) => {
    if (purchasing) return;
    if (!rcPackage) {
      console.warn("[RevenueCat] No package available for the selected plan.");
      return;
    }
    setPurchasing(true);
    setActionError(null);
    try {
      const result = await purchasePackage(rcPackage, user?.emailAddress);

      // The SDK can resolve without actually granting the entitlement (e.g. a
      // trial SetupIntent that Stripe accepts but RevenueCat never finalizes
      // into a subscription). Treat "success" as the premium entitlement
      // actually being active — otherwise we'd send the user to /home only to
      // bounce them back to the paywall on their next load.
      if (!isEntitled(result?.customerInfo)) {
        setActionError(
          "We couldn't confirm your subscription. If you were charged, please contact support — you were not sent into the app to avoid a broken session."
        );
        return;
      }

      let freshUser = { ...user, subscribed: true };
      try {
        const idToken = await auth.currentUser.getIdToken();
        const res = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_MAMAZEN_API_BASE_URL}me`,
          headers: { Authorization: idToken, token_type: "firebase" },
        });
        // Webhook may not have landed yet — RevenueCat already confirmed the
        // entitlement above, so keep the optimistic flag through webhook lag.
        freshUser = { ...res.data, subscribed: res.data?.subscribed || true };
      } catch (err) {
        console.warn("[RevenueCat] /me refresh after purchase failed:", err);
      }

      dispatch(
        setAuth({ isLoading: false, isAuthenticated: true, data: freshUser })
      );
      navigate("/myAccount/home");
    } catch (err) {
      // Cancelled by the user, or checkout failed.
      console.warn("[RevenueCat] purchase not completed:", err);
    } finally {
      setPurchasing(false);
    }
  };

  return (
    <div>
      <div className="purchase_sc_top">
        <div className="top_shape d_flex justify_content_center align_items_center">
          <div className="pr_logo">
            <img src={purchase_logo} alt="" />
          </div>
        </div>
      </div>
      <br />
      <h3>
        Become a calmer & <br />
        happier mama{" "}
      </h3>
      <p>Happy Moms = Happy Kids</p>
      <div className="purchase_sc_body">
        <h4>
          How Your Free <br />
          Trial Works
        </h4>
        {/* timeline  */}
        <TimeLine />
        <br />
        {/*  */}
        {/*<h3>Unlock All Features</h3>*/}
        {/*/!*  *!/*/}
        {/*<p*/}
        {/*  role="button"*/}
        {/*  onClick={toggleModal}*/}
        {/*  tabIndex="0"*/}
        {/*  className="cursor_pointer user_select_none text_primary"*/}
        {/*>*/}
        {/*  View All Plans*/}
        {/*</p>*/}
        {/* features */}
        <Features />
        {/* badge gradient card */}
        <GradientCard />
        {/*  */}
        <h4>Unlock 250+ Guided Mindpower Sessions</h4>
        <h5>Including these member favorites:</h5>
        {/* features # 2*/}
        <Features2 />
        {/* Testimonial */}
        <Testimonial />
        {/* Brands */}
        <Brands />
        {/*  */}
        {/*<h3>Unlock All Features</h3>*/}
        {/*/!*  *!/*/}
        {/*<p*/}
        {/*  role="button"*/}
        {/*  onClick={toggleModal}*/}
        {/*  tabIndex="0"*/}
        {/*  className="cursor_pointer user_select_none text_primary"*/}
        {/*>*/}
        {/*  View All Plans*/}
        {/*</p>*/}
        {/* FAQS */}
        <Faqs />
        {/* logout */}
        <button
          onClick={() => auth.signOut()}
          className="text_white hover_scale cs_btn text_decoration_none"
        >
          Logout
        </button>
        <br />
        {/* bottom fixed button */}
        <div className="purchase_bottom_card">
          <button
            onClick={() => startPurchase(packages.yearly)}
            disabled={purchasing || planPrices.loading}
            className={`cs_btn w_100
             ${selectedPlan === "Yearly" ? " " : " d_none"}
            `}
          >
            {purchasing ? "PROCESSING..." : "GET STARTED"}
            <span>with a {planPrices.trial_period} day FREE trial</span>
          </button>
          <button
            onClick={() => startPurchase(packages.monthly)}
            disabled={purchasing || planPrices.loading}
            className={`cs_btn w_100
              ${selectedPlan === "Monthly" ? " " : " d_none"}
              `}
          >
            {purchasing ? "PROCESSING..." : "GET STARTED"}
          </button>
          <p className="text_gray" style={{ margin: "9px auto" }}>
            {selectedPlan === "Yearly"
              ? `$${
                  planPrices?.loading ? "loading.." : planPrices.yearly
                } per year after ${planPrices.trial_period}-day FREE trial.`
              : `Just $${
                  planPrices?.loading ? "loading.." : planPrices.monthly
                } per month. Starts today`}
          </p>
          <span>{selectedPlan === "Yearly" ? `Just $${planPrices?.loading ? "loading.." : (planPrices.yearly / 12).toFixed(2)} per month` : ``}</span>
          <div className="d_flex justify_content_center align_items_center text_center">
            <a
              className="terms_link"
              href="https://www.mamazen.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span className="terms_link"> & </span>
            <a
              className="terms_link"
              href="https://www.mamazen.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          </div>
        </div>
        {/* payment plans modal */}
        {purchaseModal ? (
          <div className="payment_select_modal">
            {actionError ? (
              <p style={{ color: "#c0392b", fontSize: 14, marginBottom: 12, textAlign: "center" }}>
                {actionError}
              </p>
            ) : null}
            <div className="d_flex justify_content_end align_items_center">
              <h5
                style={{ paddingRight: "5px" }}
                className="text_blue text_uppercase"
              >
                Best Value
              </h5>
            </div>
            {/*  */}
            <button
              onClick={() => selectAPlan("Yearly")}
              className={`price_btn save ${
                selectedPlan === "Yearly" ? " selectedPkg" : ""
              }`}
              data-save="Save 62%"
            >
              <div className="price_btn_top d_flex align_items_center">
                <h5 className="text_primary">Annual</h5>
                <h5 className="price">
                  ${planPrices?.loading ? "loading.." : planPrices.yearly} /
                  year
                </h5>
              </div>
              <div className="price_btn_bottom">
                <p className="text_blue">{planPrices.trial_period} day FREE TRIAL</p>
                <span>
                  Just $
                  {(planPrices?.loading
                    ? "loading.."
                    : planPrices.yearly / 12
                  ).toFixed(2)}{" "}
                  per month
                </span>
              </div>
              {selectedPlan === "Yearly" && (
                <BlueTickIcon className={"selectedPkgItem"} />
              )}
            </button>
            <button
              onClick={() => selectAPlan("Monthly")}
              className={`price_btn ${
                selectedPlan === "Monthly" ? " selectedPkg" : ""
              }`}
            >
              <div className="price_btn_top d_flex align_items_center">
                <h5 className="text_primary">Monthly</h5>
                <h5 className="price">
                  ${planPrices?.loading ? "loading.." : planPrices.monthly} / mo
                </h5>
              </div>
              <div className="price_btn_bottom">
                <p className="text_blue">Starts Today</p>
              </div>
              {selectedPlan === "Monthly" && (
                <BlueTickIcon className={"selectedPkgItem"} />
              )}
            </button>
            {/*  */}
            {selectedPlan === "Yearly" && (
              <p className="text_gray">with a {planPrices.trial_period} day FREE trial</p>
            )}
            <div className="d_flex justify_content_center align_items_center text_center">
              <a
                className="terms_link"
                href="https://www.mamazen.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <span className="terms_link"> & </span>
              <a
                className="terms_link"
                href="https://www.mamazen.com/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
            </div>
            <button onClick={closeModal} className="cs_btn w_100">
              Continue
            </button>
            <p className="text_gray" style={{ marginTop: "9px" }}>
              {selectedPlan === "Yearly"
                ? `$${
                    planPrices?.loading ? "loading.." : planPrices.yearly
                  } per year after ${planPrices.trial_period}-day FREE trial.`
                : `Just $${
                    planPrices?.loading ? "loading.." : planPrices.monthly
                  } per month. Starts today`}
            </p>
          </div>
        ) : null}
        {purchaseModal && (
          <div
            onClick={closeModal}
            className="payment_select_modal_backdrop"
          ></div>
        )}
      </div>
    </div>
  );
};

export default Purchase;
